import React from "react";
import ThemedButton from '../../components/ui/ThemeButton';

interface AboutProps {
  about?: {
    title?: string;
    description?: string;
    buttonText?: string;
  };
  themeColor?: string;
  logo:string
}

const MicrositeAbout: React.FC<AboutProps> = ({
  about = {},
  themeColor = "#885ABB",
  logo
}) => {
  const title = about.title || "About";
  const description =
    about.description;
  const buttonText = about.buttonText || "Book Appointment";

  const scrollToTestimonial = () => {
    const element = document.getElementById("testimonial");
    if (element) {
      const offset = 80;
      const position =
        element.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: position, behavior: "smooth" });
    }
  };
  const scrollToContact = () => {
    const element = document.getElementById("contact");
    if (element) {
      const offset = 80;
      const position =
        element.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: position, behavior: "smooth" });
    }
  };

  return (
     <div    className="pt-20 py-16 px-6 md:px-24 flex flex-col items-start space-y-8 max-w-5xl mx-auto font-serif">
      {/* Logo and Tooltip */}
      <div className="flex items-center space-x-3 relative">
        <div onClick={scrollToTestimonial} className="cursor-pointer group relative">
          <img
            src={logo}
            alt="Salon Logo"
            className="w-16 h-16 rounded-full border shadow-sm object-cover transition-transform duration-200"
          />
        </div>

        <div className="relative bg-gray-800 text-white px-3 py-1 rounded-md text-sm font-serif">
          Click here to see what our clients say.
          <div className="absolute top-1/2 -left-1 w-3 h-3 bg-gray-800 rotate-45 -translate-y-1/2"></div>
        </div>
      </div>

      {/* Title */}
      <h2 className="text-3xl font-semibold font-serif">{title}.</h2>

      {/* Description */}
      <p className="text-gray-800 leading-relaxed text-lg max-w-3xl break-words">{description}</p>

      {/* Book Now Button */}
      <ThemedButton themeColor={themeColor} onClick={scrollToContact}
      className="px-6 py-2 rounded-md border transition-colors duration-300 hover:bg-white hover:text-black hover:border-gray-300">
        {buttonText}
      </ThemedButton>
     </div>
  );
};

export default MicrositeAbout;
